import React, { useState } from 'react';
import styled from 'styled-components';
import PrivacyKo from './PrivacyKo';
import PrivacyEn from './PrivacyEn';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { useLanguageStore } from '../../shared/store/languageStore';
import { DeviceType, Language } from '../../shared/enum/EnumRepository';

const Privacy: React.FC = () => {
  const { deviceType } = useDeviceStore();
  const [language, setLanguage] = useState(() => useLanguageStore.getState().language);

  return (
    <Container $deviceType={deviceType}>
      <LanguageSelector>
        <LanguageOption
          $isActive={language === Language.KR}
          onClick={() => setLanguage(Language.KR)}
        >
          KOR
        </LanguageOption>
        <LanguageDivider>/</LanguageDivider>
        <LanguageOption
          $isActive={language === Language.EN}
          onClick={() => setLanguage(Language.EN)}
        >
          ENG
        </LanguageOption>
      </LanguageSelector>
      {language === Language.KR ? <PrivacyKo /> : <PrivacyEn />}
    </Container >
  );
};

export default Privacy;

const Container = styled.main<{ $deviceType: DeviceType }>`
  width: ${({ $deviceType }) => $deviceType === DeviceType.MOBILE ? '100%' : $deviceType === DeviceType.TABLET ? '80%' : '45%'};
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: ${({ $deviceType }) => $deviceType === DeviceType.MOBILE ? '12vh 5vw' : '10vh 6vh 8vh 6vw'};
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const LanguageOption = styled.button<{ $isActive: boolean }>`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.color_Gray_04 : theme.colors.color_Gray_05
  };
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.color_Gray_04};
  }
`;

const LanguageDivider = styled.span`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  user-select: none;
`;